import { styled, ToggleButton, Tooltip, useTheme } from '@mui/material';
import { HierarchyLevels } from '@retail/products/types';
import { chipColor } from '@retail/calculus/utils';
import { PackageType } from '@retail/calculus/types';

interface Props {
  level: HierarchyLevels;
  packageType?: PackageType;
  nrOfLevels: number;
  levelName: string;
  levelNameShort: string;
}

export const LevelToggleButton = ({
  level,
  packageType,
  nrOfLevels,
  levelName,
  levelNameShort,
}: Props) => {
  const theme = useTheme();

  const buttonPaddingX = nrOfLevels > 7 ? 12 : nrOfLevels > 6 ? 16 : nrOfLevels > 4 ? 18 : 24;
  const { bg, text } = chipColor({
    palette: theme.vars.palette,
    bindingType: level,
    packageType,
    active: true,
  });
  return (
    <Tooltip title={levelName}>
      <StyledToggleButton
        value={packageType ?? level}
        paddingx={buttonPaddingX}
        buttoncolor={bg}
        textcolor={text}
      >
        {levelNameShort}
      </StyledToggleButton>
    </Tooltip>
  );
};

const StyledToggleButton = styled(ToggleButton)<{
  buttoncolor: string;
  textcolor: string;
  paddingx: number;
}>(({ buttoncolor, textcolor, paddingx, theme }) => ({
  background: `${buttoncolor} !important`,
  paddingLeft: `${paddingx}px !important`,
  paddingRight: `${paddingx}px !important`,
  color: `${textcolor} !important`,
  '&.Mui-selected, &:focus, &:hover': {
    outline: `2px solid ${theme.vars.palette.common.black} !important`,
  },
  ...theme.applyStyles('dark', {
    '&.Mui-selected, &:focus, &:hover': {
      outlineColor: `${textcolor} !important`,
    },
  }),
}));
